var React = require('react');

function Bolt2 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .svg-fill {\n       \n        stroke-miterlimit: 10;\n        stroke-width: 22px;\n      \n      }\n    ")),React.createElement("title",{"key":1},"bolt"),React.createElement("ellipse",{"className":"svg-fill","cx":"246.53","cy":"248","rx":"241.53","ry":"243","key":2}),React.createElement("polygon",{"points":"247.15 70.45 247.15 209.26 134.4 209.26 247.15 423.25 247.15 284.44 359.9 284.44 247.15 70.45","key":3})]);
}

Bolt2.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 493.06 496"};

module.exports = Bolt2;

Bolt2.default = Bolt2;
